export var APPLICATION_STATUS = {
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  CONDITIONED: 'CONDITIONED',
  APPROVED: 'APPROVED',
  DECLINED: 'DECLINED',
  WITHDRAWN: 'WITHDRAWN'
};
export var APPLICATION_TYPES = {
  INDIVIDUAL: 'INDIVIDUAL',
  INDIVIDUAL_WITH_CO_APPLICANT: 'INDIVIDUAL_WITH_CO_APPLICANT',
  BUSINESS: 'BUSINESS',
  BUSINESS_WITH_CO_APPLICANT: 'BUSINESS_WITH_CO_APPLICANT',
  BUSINESSGUARANTOR: 'BUSINESSGUARANTOR'
};
export var CREDIT_AGENCIES = {
  ROUTEONE: 'ROUTEONE',
  CUDL: 'CUDL',
  VW_CREDIT: 'VW_Credit',
  DEALER_TRACK: 'DEALER_TRACK',
  AUDI_FINANCIAL_SERVICES: 'AUDI_FINANCIAL_SERVICES',
  MERCEDES_BENZ_FINANCIAL_SERVICES: 'MERCEDES_BENZ_FINANCIAL_SERVICES',
  BMW_FINANCIAL_SERVICES: 'BMW_FINANCIAL_SERVICES'
};